<template>
  <img class="h-10 w-auto" :src="brandService.getLogo()" />
</template>

<script setup lang="ts">
import { injectStrict } from '../../plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '../../services/brand/brandServiceInterface';

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');
</script>
